import zsmLayout from '@/zsm-layout'

const agentIncomeRouter = {
  path: '/agent/income',
  component: zsmLayout,
  name: 'lecturer',
  hidden: true,
  children: [
    {
      path: '/agent/income',
      component: () => import('@/view/agent-income/index'),
      name: 'lecturer'
    },
    {
      path: '/agent/fund',
      component: () => import('@/view/agent-income/account'),
      name: 'orderStatistics',
      redirect: '/agent/fund/alipay',
      // hidden: true,
      children: [{
        path: '/agent/fund/alipay',
        component: () => import('@/view/agent-income/alipay-account'),
        name: 'orderStatistics',
        hidden: true
      },
      {
        path: '/agent/fund/bank',
        component: () => import('@/view/agent-income/bank-account'),
        name: 'orderStatistics',
        hidden: true
      }
      ]
    }
  ]
}

export default agentIncomeRouter
